import { Fragment, useMemo } from "react";
import { DataProvider } from "../../shared/DataProvider";
import "./styles.scss";
import { AnnotationTypes } from "../../shared/constants";
import { IAnnotationData } from "../../shared/types";

interface INotebookDrawer {
  annotationUpdated: boolean;
  onClose: () => void;
}

export const NotebookDrawer = ({ annotationUpdated, onClose }: INotebookDrawer) => {
  const noteAnnotationsByScreenId = useMemo(() => {
    const annotationsMap = DataProvider.getAnnotations() as Map<string, IAnnotationData[]>;
    const notesByScreenId: Record<string, IAnnotationData[]> = {};

    annotationsMap.forEach((annotations, screenId) => {
      const notes = annotations?.filter(
        (annotation) => annotation.annotationType === AnnotationTypes.Highlight,
      );

      if (notes.length) {
        notesByScreenId[screenId] = notes;
      }
    });

    return notesByScreenId;
  }, [annotationUpdated]);

  const clickHandler = (annotationData: IAnnotationData) => {
    window.__viewerApi.route(annotationData.screenId, { annotation: annotationData });
  };

  return (
    <div className="drawer notebook-drawer">
      <div className="header">
        <h3 className="title">Notebook</h3>
        <button className="close-button" aria-label="Close button" onClick={onClose}>
          <div className="close-icon" />
        </button>
      </div>

      <div className="drawer-body">
        {Object.keys(noteAnnotationsByScreenId).map((screenId) => (
          <Fragment key={screenId}>
            {noteAnnotationsByScreenId[screenId]?.map((annotationData) => (
              <div
                className="note-item"
                key={annotationData.annotationId}
                onClick={() => clickHandler(annotationData)}
              >
                <div className="screen-title">{annotationData.screenTitle}</div>

                <div className={`selected-text ${annotationData.color?.toLocaleLowerCase()}`}>
                  <span className="ellipsis">{annotationData.selectedText}</span>
                </div>

                <div>{annotationData.noteText}</div>
              </div>
            ))}
          </Fragment>
        ))}
      </div>
    </div>
  );
};
